// Translation: Interface > Pagination (Ukrainian)
export default Object.freeze({
	options: {
		first: {
			label: ''
		},
		last: {
			label: ''
		},
		next: {
			label: ''
		},
		previous: {
			label: ''
		}
	}
})
